import { render } from "./EditPublication.vue?vue&type=template&id=7a5d183d&ts=true"
import script from "./EditPublication.vue?vue&type=script&lang=ts"
export * from "./EditPublication.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__